import { BORDER_COLOR } from "../../theme";

export const selectEnterpriseStyles = {
    mainContainer: {
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        maxHeight: "100vh",
        overflowY: "scroll",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
            display: "none",
        },
    } as const,
    gridContainer: {
        maxWidth: "100vw",
        display: "flex",
        justifyContent: "center",
        gap: "20px",
        marginTop: "15px",
        flexWrap: "wrap",
    } as const,
    enterpriseImage: {
        width: "160px",
        height: "160px",
        borderRadius: "10px",
    } as const,
    enterpriseCard: {
        border: `1px solid ${BORDER_COLOR}`,
        width: "200px",
        height: "220px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "10px",
        borderRadius: "10px",
        padding: "10px",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
            transform: "scale(1.1)",
            cursor: "pointer",
        },
    } as const,
    typography: {
        width: "100%",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textAlign: "center",
    } as const,
}